import { ExposedInstanceDependencies } from '../common';
import type { Metadata } from '../types';

/**
 * @param bundledWith THe MFE's metadata.bundledWith.
 * @param exposedInstanceDependencies The hosts's EXPOSED_INSTANCE_DEPENDENCIES, if any.
 * @returns Returns true when host and MFE use compatible version of LaunchDarkly
 * and returns false when host and MGE use incompatible version.
 * Returns undefined when either the host or MFE doesn't expose LaunchDarkly.
 */
export function getMFEHasCompatibleLaunchDarklyVersion(
    bundledWith: Metadata['bundledWith'],
    exposedInstanceDependencies: ExposedInstanceDependencies
) {
    const mfeVersion = bundledWith?.['launchdarkly-js-client-sdk'];
    const hostVersion = exposedInstanceDependencies.launchDarkly?.version;
    if (hostVersion && mfeVersion) {
        return hostVersion === mfeVersion;
    }
}
